module.exports = __webpack_public_path__ + "static/video-difusion-9dde0ad3afb96e07c20fb2412593f10c.png";